<div class="page-bg"></div>
<div class="page-container">
    <div class="row flex-nowrap fixed-top bg">
        <div class="col-6 d-none d-lg-block p-0">
            <div><div></div></div>
            <div><div></div></div>
            <div><div></div></div>
            <div><div></div></div>
        </div>
        <div class="col-6 d-none d-lg-block p-0">
            <div><div></div></div>
            <div><div></div></div>
            <div><div></div></div>
            <div><div></div></div>
        </div>
    </div>
    <router-outlet></router-outlet>
</div>
